import { Search } from '@app/components/various/Search';
import { getLookbookPageIdsGroupedBySlug } from '@app/logic/lookbook';
import { includesSearchIgnoreCase } from '@app/utils/includes';
import { isEmpty } from '@app/utils/isEmpty';
import { useTranslation } from 'react-i18next';

import { useLookbookNavigationSettingsContext } from '../LookbookNavigationSettingsContext';

import { AvailablePageItem } from './AvailablePageItem';

export const PagesForm = () => {
  const { addedMenuItems, setSearchPhrase, searchPhrase, pagesRecords } = useLookbookNavigationSettingsContext();

  const { t } = useTranslation(['common', 'lookbook', 'settings']);

  const publishedPages = Object.values(pagesRecords);
  const groupedPageIds = getLookbookPageIdsGroupedBySlug(publishedPages);

  const addedIds = addedMenuItems.reduce((acc, cur) => {
    const childItems = cur.children?.map(child => child.pageId) ?? [];

    return [...acc, cur.pageId, ...childItems];
  }, []);

  const notAddedPageIds = groupedPageIds.filter(id => !addedIds.includes(id));

  const filteredNotAddedPageIds =
    isEmpty(searchPhrase) ? notAddedPageIds : (
      notAddedPageIds.filter(id => {
        const { name = '', slug = '' } = pagesRecords[id] ?? {};

        return includesSearchIgnoreCase(name, searchPhrase) || includesSearchIgnoreCase(slug, searchPhrase);
      })
    );

  return (
    <>
      <Search placeholder={t('settings:page_search_placeholder')} value={searchPhrase} onChange={setSearchPhrase} size="regular" isFluid />

      {isEmpty(filteredNotAddedPageIds) ?
        <div className="p-10 text-center body-5">{t('lookbook:navigation.no_pages_available')}</div>
      : <div className="mt-1 max-h-96 overflow-auto">
          <ul data-testid="navigationMenuItems" className="m-0 flex flex-col gap-1 p-0">
            {filteredNotAddedPageIds.map(id => (
              <AvailablePageItem key={id} pageId={id} />
            ))}
          </ul>
        </div>
      }
    </>
  );
};
